module.exports = __webpack_public_path__ + "static/media/sparkle.490243f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/static/icons/sparkle.png
// module id = 236
// module chunks = 0